import {ComponentStatus, ComponentStatusValue} from "@/lib/types/statuspages.ts";

export const NO_CHANGE_OPTION: ComponentStatus = {
  value: ComponentStatusValue.NO_CHANGE,
  display: "No Change",
  rank: -1,
  color: "",
  is_operational: true,
  is_failure: false,
};
